import HttpClient from '@/utils/HttpClient';
import projectStore from '@/store/Projects';
export default {
  getAll() {
    return HttpClient.getAuthenticated(`/api/projects/${projectStore.activeProject.DbId}/pats`);
  },
  getById(id) {
    return HttpClient.getAuthenticated(`/api/projects/${projectStore.activeProject.DbId}/pats/${id}`);
  },
  create(pat) {
    return HttpClient.postAuthenticated(`/api/projects/${projectStore.activeProject.DbId}/pats`, { pat });
  },
  update(pat) {
    return HttpClient.updateAuthenticated(`/api/projects/${projectStore.activeProject.DbId}/pats`, { pat });
  },
  delete(pat) {
    return HttpClient.deleteAuthenticated(`/api/projects/${projectStore.activeProject.DbId}/pats/${pat.DbId}`);
  },
  saveDecision(decision) {
    return HttpClient.postAuthenticated(
      `/api/projects/${projectStore.activeProject.DbId}/pats/${decision.PatId}/decisions`,
      { decision }
    );
  },
  getDecisionHistory(patId) {
    return HttpClient.getAuthenticated(`/api/projects/${projectStore.activeProject.DbId}/pats/${patId}/decisions`);
  },
  getAllocations(id) {
    return HttpClient.getAuthenticated(`/api/projects/${projectStore.activeProject.DbId}/pats/${id}/allocations`);
  },
  createAllocation(allocation) {
    return HttpClient.postAuthenticated(
      `/api/projects/${projectStore.activeProject.DbId}/pats/${allocation.PatId}/allocations`,
      {
        allocation
      }
    );
  },
  deleteAllocation(allocation) {
    return HttpClient.deleteAuthenticated(
      `/api/projects/${projectStore.activeProject.DbId}/allocations/pat/${allocation.DbId}`
    );
  },
  updateAllocations(patId, allocations) {
    return HttpClient.updateAuthenticated(
      `/api/projects/${projectStore.activeProject.DbId}/pats/${patId}/allocations`,
      {
        allocations
      }
    );
  }
};
